import { render, staticRenderFns } from "./sectionSummary.vue?vue&type=template&id=44282f92&scoped=true&"
import script from "./sectionSummary.vue?vue&type=script&lang=js&"
export * from "./sectionSummary.vue?vue&type=script&lang=js&"
import style0 from "./sectionSummary.vue?vue&type=style&index=0&id=44282f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44282f92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44282f92')) {
      api.createRecord('44282f92', component.options)
    } else {
      api.reload('44282f92', component.options)
    }
    module.hot.accept("./sectionSummary.vue?vue&type=template&id=44282f92&scoped=true&", function () {
      api.rerender('44282f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/sectionSummary.vue"
export default component.exports